<template>
    <div class="row" >
        <div class="col-xl-3 col-sm-6 mb-3">
            <div class="card text-white bg-success o-hidden h-100">
                <div class="card-body">
                    <div class="">
                        <h6>R$ {{ticket}}</h6>
                        <small>Ticket Médio dos últimos 30 dias</small>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-xl-3 col-sm-6 mb-3">
            <div class="card text-white bg-primary o-hidden h-100">
                <div class="card-body">
                    <div class="">
                        <h6>R$ {{total}}</h6>
                        <small>{{sales}} novas nos últimos 30 dias</small>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-xl-3 col-sm-6 mb-3">
            <div class="card text-white bg-secondary o-hidden h-100">
                <div class="card-body">
                    <div class="">
                        <h6>{{total_products}}</h6>
                        <small>Produtos em estoque</small>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-xl-3 col-sm-6 mb-3">
            <div class="card text-white bg-danger o-hidden h-100">
                <div class="card-body">
                    <div class="">
                        <h6>R$ {{total_sales}}</h6>
                        <small>Total em preço de venda</small>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
	export default {
		name: 'cardListDashFaturamento',
        data(){
            return{
				ticket     : 0,
				sales : 0,
				total    : 0,
                total_sales   : 0,
                total_products   : 0,

				interval		: 0
            }
		},
		computed: {
			getToken(){
				return this.$store.getters.getToken
			}
		},
		methods: {
			getData: function(){
				fetch(server + 'resumos/financeiro', {
                    method: 'GET',
                    headers: new Headers({
                        'token' : this.getToken
                    })
                })
					.then(response => (response.json()) )
					.then(responseJSON => {
                        if(responseJSON.data == true){
                            this.ticket        = responseJSON.response[0].ticket
                            this.sales    = responseJSON.response[0].sales
                            this.total       = responseJSON.response[0].total
                            this.total_sales      = responseJSON.response[0].total_sales
                            this.total_products      = responseJSON.response[0].total_products
                        }else{
                            this.ticket         = 0
                            this.sales          = 0
                            this.total          = 0
                            this.total_sales    = 0
                            this.total_products = 0
                        }

					})
					.catch(error => {
                        // console.log('Erro exception', '=>', error)
                        this.ticket         = 0
                        this.sales          = 0
                        this.total          = 0
                        this.total_sales    = 0
                        this.total_products = 0
					})
			},
			syncData: function(){
				this.interval = setInterval(() => {
					this.getData()
				}, 30000)
			}
		},
		mounted(){
			this.getData()
		},
		created(){
			
        },
        beforeRouterEnter(to, from, next){
            this.syncData()
        },
        beforeRouterLeave(to, from, next){
            clearInterval(this.interval)
        }
	}
</script>

<style scoped>
</style>
